import * as React from "react";

export interface ISelectorViewProps {
    selection: string;
    option1: string,
    option1Label: string,
    option2: string,
    option2Label: string,
    option3?: string,
    option3Label?: string,
    setSelection: (selection: string) => void,
    selectorTitle?: string
    disabled?: boolean;
    customStyle?: string;
    key?: string;
    fullSize?: boolean;
}

const SelectorView: React.SFC<ISelectorViewProps> = ({ 
    selection, 
    key, 
    setSelection, 
    option1, 
    option1Label,
    option2, 
    option2Label, 
    option3,
    option3Label,
    selectorTitle, 
    disabled, 
    customStyle, 
    fullSize 
}) => {
    const options = [
        { value: option1, label: option1Label },
        { value: option2, label: option2Label }
    ];

    if (option3 && option3Label) {
        options.push({ value: option3, label: option3Label });
    }

    const highlightIfSelected = buttonValue => {
        if (buttonValue === selection) {
            return "selectorRadioButtonSelected"
        }
        else return "selectorRadioButtonUnSelected"
    }

    const customStyleValue: string = customStyle && customStyle.length > 0 ? `selectorRadioButtonsDiv ${customStyle}` : 'selectorRadioButtonsDiv';
    const fullSizeValue: string = fullSize ? "selectorView" : "form-group col-md-4 col-sm-6 selectorView"
    if (!disabled) {
        return (
            <div key={key} className={fullSizeValue}>
                <label className="selectorTitle">{selectorTitle}</label>
                <div className={customStyleValue}>
                    {options.map((option, index) => (
                        <div
                            className={options.length === 2
                                ? (index === 0 ? "selectorRadioButtonsLeftSubDiv" : "selectorRadioButtonsRightSubDiv")
                                : "selectorRadioButtonsOptionSubDiv"}
                            key={`${option.value}-${index}`}
                        >
                            <input
                                type="button"
                                onClick={() => setSelection(option.value)}
                                value={option.label}
                                className={["selectorRadioButtonsText", highlightIfSelected(option.value)].join(' ')}
                                data-testid={`${selectorTitle} option${index + 1}`}
                            />
                        </div>
                    ))}
                </div>
            </div>
        );
    }
    else {
        return (
            <div className="form-group col-md-4 col-sm-6 selectorViewDisabled">
                <label className="selectorTitle">{selectorTitle}</label>
                <div className="selectorRadioButtonsDiv">
                    {options.map((option, index) => (
                        <div
                            className={options.length === 2
                                ? (index === 0 ? "selectorRadioButtonsLeftSubDiv" : "selectorRadioButtonsRightSubDiv")
                                : "selectorRadioButtonsOptionSubDiv"}
                            key={`${option.value}-${index}`}
                        >
                            <input
                                type="button"
                                onClick={null}
                                value={option.label}
                                className={["selectorRadioButtonsText", highlightIfSelected(option.value)].join(' ')}
                            />
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

export default SelectorView;